export enum ServiceType {
	None,
	Canvas,
	Measurements,
}
